import { render, staticRenderFns } from "./Badge15.vue?vue&type=template&id=f198d1e4&scoped=true"
import script from "./Badge15.vue?vue&type=script&lang=js"
export * from "./Badge15.vue?vue&type=script&lang=js"
import style0 from "./Badge15.vue?vue&type=style&index=0&id=f198d1e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f198d1e4",
  null
  
)

export default component.exports